import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const inputCls = "w-full rounded-xl border border-white/10 bg-[#0f0f13] px-4 py-3 text-sm text-white outline-none focus:border-[#f5c542]";

export default function EditPage() {
  const { token } = useParams();
  const [reg, setReg] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get(`/registrations/${token}`).then((r) => setReg(r.data)).catch(() => setNotFound(true));
  }, [token]);

  const set = (k, v) => setReg((r) => ({ ...r, [k]: v }));

  const save = async () => {
    try {
      await api.put(`/registrations/${token}`, { ...reg, companions: Number(reg.companions) || 0 });
      setSaved(true);
      toast.success("Risposta aggiornata!");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  if (notFound) return <div className="grid min-h-screen place-items-center bg-[#050505] px-6 text-center text-white/60">Registrazione non trovata.</div>;
  if (!reg) return <div className="grid min-h-screen place-items-center bg-[#050505]"><div className="h-8 w-8 animate-spin rounded-full border-2 border-white/10 border-t-[#f5c542]" /></div>;

  return (
    <div className="min-h-screen bg-[#050505] px-6 py-16">
      <div className="mx-auto max-w-xl">
        <h1 className="font-display text-3xl font-black tracking-tight">Modifica la tua risposta</h1>
        <p className="mt-2 text-white/50">Aggiorna i tuoi dati e salva le modifiche.</p>

        <div className="mt-8 space-y-4 rounded-2xl border border-white/10 bg-[#0f0f13]/70 p-6">
          <div className="grid gap-4 sm:grid-cols-2">
            <input className={inputCls} value={reg.first_name} onChange={(e) => set("first_name", e.target.value)} placeholder="Nome" />
            <input className={inputCls} value={reg.last_name} onChange={(e) => set("last_name", e.target.value)} placeholder="Cognome" />
          </div>
          <input className={inputCls} value={reg.email} onChange={(e) => set("email", e.target.value)} placeholder="Email" />
          <input className={inputCls} value={reg.phone} onChange={(e) => set("phone", e.target.value)} placeholder="Telefono" />
          <div className="grid gap-4 sm:grid-cols-2">
            <select className={inputCls} value={reg.attending} onChange={(e) => set("attending", e.target.value)}>
              <option value="yes">Sì, parteciperò</option>
              <option value="no">No, non potrò partecipare</option>
            </select>
            <select className={inputCls} value={reg.tournament} onChange={(e) => set("tournament", e.target.value)}>
              <option value="nessuno">Nessun torneo</option>
              <option value="padel">Torneo di Padel</option>
              <option value="beach">Beach Volley</option>
              <option value="entrambi">Entrambi</option>
            </select>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <select className={inputCls} value={reg.tshirt} onChange={(e) => set("tshirt", e.target.value)}>
              <option value="">Taglia maglietta</option>
              {["XS", "S", "M", "L", "XL", "XXL"].map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
            <select className={inputCls} value={reg.diet} onChange={(e) => set("diet", e.target.value)}>
              <option value="nessuna">Nessuna preferenza</option>
              <option value="vegetariana">Vegetariana</option>
              <option value="vegana">Vegana</option>
              <option value="senza_glutine">Senza glutine</option>
              <option value="allergie">Intolleranze/Allergie</option>
            </select>
          </div>
          <button onClick={save} className="btn-neon flex w-full items-center justify-center gap-2 rounded-xl py-3 font-display text-sm font-extrabold uppercase tracking-wider" data-testid="edit-save-btn">
            {saved ? <><Check size={16} /> Salvato</> : "Salva modifiche"}
          </button>
        </div>
      </div>
    </div>
  );
}
